<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/monitorings' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header class="header left">
        <h1>{{ $t('info') }} {{ $t('projectPrice') }} </h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
          <div class="row">
            <span class="label">{{ $t('project')  + ' *' }}</span>
            <div class="inputs">
              <heim-select
                :data="projects"
                label-key="name"
                value-key="id"
                v-model="project_id"
                required="required"
              ></heim-select>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('info')  + ' *' }}</span>
            <div class="inputs">
              <heim-input :label="$t('soldPrice') + ' *'" name="clientprice" type="number" v-model="clientPrice" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('clientprice')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('clientprice') }}</span>

              <heim-input :label="$t('numberDayPrice') + ' *'" name="clientdays" v-model="clientDays" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('clientdays')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('clientdays') }}</span>

              <heim-input :label="'Prix objectif *'" name="objectiveprice" type="number" v-model="objectivePrice" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('objectiveprice')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('objectiveprice') }}</span>

              <heim-input :label="'Nombre jours objectif *'" name="objectivedays" v-model="objectiveDays" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('objectivedays')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('objectivedays') }}</span>

              <div class="toggle-box"><span class="label">Activer</span><heim-toggle-button name="active" v-model="active"></heim-toggle-button></div>
            </div>
          </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimTextarea from "@/components/form/input/text/heim-textarea.vue";
import HeimToggleButton from "@/components/form/input/toggle/heim-toggle-button.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import Places from "vue-places";

import { mapState } from "vuex";
export default {
  name: "MonitoringsNew",
  components: {
    HeimInput,
    HeimTextarea,
    HeimToggleButton,
    HeimSelect,
    HeimButton,
    HeimCard,
    HeimIcon,
    Places
  },
  mounted() {
    this.$store.dispatch("getAllProjects");
  },
  data() {
    return {
      project_id: "",
      clientDays: "",
      clientPrice: "",
      objectiveDays: "",
      objectivePrice: "",
      active: false
    };
  },
  computed: {
    ...mapState({ projects: state => state.monitoringsState.projectsList })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("createProjectContract", {
        project_id: this.project_id,
        clientDays: this.clientDays,
        clientPrice: this.clientPrice,
        objectiveDays: this.objectiveDays,
        objectivePrice: this.objectivePrice,
        active: this.active
      });
      this.$validator.validateAll().then(result => {
        if (result && data) {
          this.$store.dispatch("setToastMessage", {
            message: "Les données ont été enregistrées"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/monitorings` });
        }
      });
    }
  }
};
</script>

<style>
input.paper-input,
.ap-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}

input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

.search-location {
  display: block;
  margin: 0 auto;
  margin-top: 5vw;
  font-size: 20px;
  font-weight: 400;
  outline: none;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
}
</style>

<style scoped>
.toggle-box {
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
}
.toggle-box .label {
  display: inline-block;
  margin-bottom: 0.6em;
}

.heim-input .label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}

.ap-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}
</style>
